import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  RadioGroup,
  Radio,
  Typography,
  FormControl,
  FormControlLabel,
  FormLabel,
  FormGroup,
} from '@material-ui/core'
import {
  downloadReport,
  downloadReportProgram,
  fetchConnectedPartnerPrograms,
} from 'features/analytics/analyticsSlice'
import { Button, Wrapper, Select } from 'sputnik-ui'
import { useFormik } from 'formik'
import ym from 'react-yandex-metrika'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'


export default function PartnerProgramAnalytics({
  formatDate,
  ResDiv,
  BlueRadio,
  Content, 
  SearchIcon, 
  StartEndDatesComponent,
  fetchLocalities,
  setLocalityFilter,
  localities,
  localityFilter,
  CalendarIcon,  ...props }) {
  const [partnerProgramExport, setPartnerProgramExport] = useState(false)
  const dispatch = useDispatch()
  const { t } = useTranslation(['analytics'])
  const pending = useSelector(({ analytics }) => analytics.pending)
  const connectedPrograms = useSelector(
    ({ analytics }) => analytics.connectedPrograms
  )
  const connectedProgramsPending = useSelector(
    ({ analytics }) => analytics.connectedProgramsPending
  )

  let kek = new Date()
  const monthAgo = kek.setMonth(kek.getMonth() - 1)
  const minDate = '2021-08-01'

  const programOptions = connectedPrograms.map((program) => ({
    value: program.id,
    label: program.name,
  }))

  const formik = useFormik({
    initialValues: {
      download_type: 'xlsx',
      start_date: formatDate(monthAgo),
      end_date: formatDate(new Date()),
      locality_uuid: undefined,
      program_id: undefined,
    },
    onSubmit: (values) => {
      partnerProgramExport
        ? dispatch(downloadReportProgram(values))
        : dispatch(downloadReport(values))
    },
  })

  useEffect(() => {
    dispatch(fetchConnectedPartnerPrograms())
  }, [dispatch])
  
  return (
     <>
      <Typography
        variant="h5"
        style={{ marginTop: '2rem', marginBottom: '1rem' }}
      >
        {t('analytics:title')}
      </Typography>
        <form onSubmit={formik.handleSubmit}>
          <Wrapper
            shadow={false}
            style={{ flexDirection: 'column', width: 'fit-content' }}
          >
            <Typography variant="h6" style={{ marginBottom: '1rem' }}>
              {t('analytics:settings')}
            </Typography>
            <ResDiv>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <FormControl
                  component="fieldset"
                  style={{
                    width: '100%',
                    minWidth: 300,
                  }}
                >
                  <Select
                    // async
                    // loadOptions={options}
                    name="locality_uuid"
                    options={localities}
                    isMulti={false}
                    // isClearable={false}
                    cacheOptions
                    defaultOptions
                    value={localityFilter}
                    onChange={(o) => {
                      dispatch(setLocalityFilter(o))
                      formik.setFieldValue('locality_uuid', o.value)
                    }}
                    placeholder={t('analytics:address_placeholder')}
                    style={{ width: '100%' }}
                  />
  
                  <Typography
                    variant="h6"
                    style={{ marginTop: '1rem', fontWeight: 400 }}
                  >
                    {t('analytics:key_indicators')}
                  </Typography>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <BlueRadio
                          checked={!partnerProgramExport}
                          onChange={(e) => {
                            setPartnerProgramExport(false)
                            formik.setFieldValue('program_id', null)
                          }}
                        />
                      }
                      label={t('analytics:download_default')}
                      name="download_default"
                    />
                    <FormControlLabel
                      control={
                        <BlueRadio
                          checked={partnerProgramExport}
                          onChange={(e) => {
                            setPartnerProgramExport(true)
                            formik.setFieldValue('program_id', null)
                          }}
                        />
                      }
                      label={t('analytics:partner_program_income')}
                      name="partner_program_income"
                    />
                  </FormGroup>
                  <Select
                    isMulti={false}
                    isClearable
                    isDisabled={
                      !partnerProgramExport || connectedProgramsPending || programOptions.length === 0
                    }
                    options={programOptions}
                    value={
                      programOptions.find(
                        (o) => o.value === formik.values.program_id
                      ) || null
                    }
                    onChange={(o) => {
                      formik.setFieldValue('program_id', o ? o.value : undefined)
                    }}
                    placeholder={
                      programOptions.length === 0
                        ? t('analytics:no_connected_programs')
                        : t('analytics:select_program_placeholder')
                    }
                    style={{ width: '100%', marginTop: '0.5rem' }}
                  />
                </FormControl>
              </div>
  
              <Content>
                <StartEndDatesComponent 
                handleChangeStartDate={formik.handleChange} 
                handleChangeEndDate={formik.handleChange} 
                minDate={formatDate(minDate)}
                values={formik.values}
                />
                <Typography variant="h6" style={{ margin: '1rem 0' }}>
                  {t('analytics:uploading_data')}
                </Typography>
  
                <FormControl>
                  <FormLabel component="legend">
                    {t('analytics:data_format')}
                  </FormLabel>
                  <RadioGroup
                    onChange={formik.handleChange}
                    value={formik.values.download_type}
                    name="download_type"
                  >
                    <FormControlLabel
                        control={<Radio />}
                        value="xlsx"
                        label=".xlsx"
                    />
                    <FormControlLabel
                      control={<Radio />}
                      value="csv"
                      label=".csv"
                    />
                  </RadioGroup>
                </FormControl>
                <Button
                  type="submit"
                  primary
                  style={{ marginTop: '1rem', marginRight: 'auto' }}
                  disabled={pending}
                >
                  {pending ? t('analytics:loading') : t('analytics:export_data')}
                </Button>
              </Content>
            </ResDiv>
          </Wrapper>
        </form>
    </>
  )
    
}
